// TableBody.jsx

'use strict';
import React, { Component } from 'react';
import TableRow from './TableRow.jsx';

class TableBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: props.data
        };
    }

    componentWillReceiveProps(nextProps) {
        this.state.data = nextProps.data;
    }

    render() {
        let parametrosRowTableNodes;
        const { props } = this;

        if (props.data != undefined && props.data != "") {
            parametrosRowTableNodes = props.data.entidades.map((entidad, index) => {
                const isWhiteRow = (index % 2 == 0);
                if (entidad.mostrar) {
                    return (
                        <TableRow
                            entidad={entidad}
                            setearEntidad={props.setearEntidad}
                            key={"TR_" + entidad.ID}
                            isWhiteRow={isWhiteRow}
                        />
                    );
                }
            });
        }
        return (
            <tbody>
                {parametrosRowTableNodes}
            </tbody>
        );
    }
}

export default TableBody